import useGetNewsTipStatuses from './useGetNewsTipStatuses'

export default useGetNewsTipStatuses
